import NewPost from "./components/Card";

export default NewPost;
